// @ts-ignore
import HttpService from '@/shared/services/HttpService';
import {IPlayer} from '@/shared/types';

class PlayerService {
    private http = new HttpService();

    public async fetchPlayerInfo(playerId?: number) {
        try {
            return await this.http.get('ap/player-teams/' + playerId);

        } catch (e) {
            return e;
        }
    }
}

export default new PlayerService();
